import { render, staticRenderFns } from "./RockportFirewood.vue?vue&type=template&id=52cb6b89&scoped=true&"
import script from "./RockportFirewood.vue?vue&type=script&lang=js&"
export * from "./RockportFirewood.vue?vue&type=script&lang=js&"
import style0 from "./RockportFirewood.vue?vue&type=style&index=0&id=52cb6b89&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "52cb6b89",
  null
  
)

export default component.exports